import { __callbacks } from "../Callbacks/Callback";
import { __debug } from "../Debug/Debug";
import { __delay } from "../Delay/Delay";
import { IChatMsgAPI, IChatQueueObject, IChatQueueObjectLocalStorage } from "../Interfaces";
import { Queue } from "../Structures/Queue";



class ChatQueue {


    private queue: IChatQueueObject = { };
    private keyLocalStorage: string = "unread_chats" + window.location.search.substr(1).split("&")[0].split("=")[1];

    constructor () {
        this.fromLocalStorage();
    }

    /**
     * initializes the events
     */
    public initEvents = () => {
        // listen to chat message receive event
        __callbacks.onChatMsgReceive((chatMsg: IChatMsgAPI) => {
            const chatId = chatMsg.chatId;

            if(this.isEmpty(chatId)) {
                this.queue[chatId] = new Queue<IChatMsgAPI>(chatId);
            }
            
            this.queue[chatId].add({ ...chatMsg });
            __delay.set("ChatQueue", () => {
                this.toLocalStorage();
            }, 1000);
        });
    }

    /**
     * returns total number of messages in the queue (i.e. unread messages)
     * @param chatId string
     * @returns number
     */
    totalMsgs = (chatId: string) : number => {
        return this.queue[chatId]?.length || 0;
    }
    /**
     * returns total number of messages of all chats (i.e. unread messages)  
     * @returns number
     */
     allMsgs = () : number => {
        var totalMsgs: number = 0;
        Object.keys(this.queue).forEach((chatId: string) => {
            totalMsgs += this.totalMsgs(chatId);
        });
        return totalMsgs;
    }
    /**
     * broadcasts/updates/triggers/refreshes events
     * @param chatId string
     * @returns void
     */
    broadcastEvents = (chatId: string) : void => {
        if(this.isEmpty(chatId)) {
            __debug.warn(() => {
                console.warn(`[ChatQueue::broadcastEvents]::No chat exists with chatId: [${chatId}] to broadcast events.`);
            });
            return;
        }
        this.queue[chatId]?.broadcastEvents();
    }
    
    /**
     * resolves chat  
     * returns messages in the queue from the given chatId  
     * removes messages from the queue and returns  
     * @param chatId string
     * @returns IChatMsgAPI[]
     */
    resolve = (chatId: string) : IChatMsgAPI[] => {
        // return unread messages

        __delay.set("ChatQueue_reslove", () => {
            this.toLocalStorage();
        }, 1000);

        return this.queue[chatId]?.resolve();
    }

    /**
     * resolves a single chat message
     * @deprecated this method is not being used currently!  
     * @param chatId string
     * @returns IChatMsgAPI
     */
    resolveOne = (chatId: string) : IChatMsgAPI => {
        // return unread messages
        return this.queue[chatId].remove();
    }

    /**
     * determines if the chat exists
     * @param chatId string
     * @returns boolean
     */
    isEmpty = (chatId: string) : boolean => {
        if(this.queue[chatId]) return false;
        return true;
    }

    /**
     * saves the state of this class in the local-storage
     */
    toLocalStorage = () => {
        const objectToSave: IChatQueueObjectLocalStorage = { };
        Object.keys(this.queue).forEach((chatId: string) => {
            objectToSave[chatId] = {
                queues: this.queue[chatId].get()
            };
        });
        localStorage.setItem(this.keyLocalStorage, JSON.stringify(objectToSave));
    }

    /**
     * retreives the state of this class from the local-storage
     */
    fromLocalStorage = () => {
        const unreadChatsStr = localStorage.getItem(this.keyLocalStorage);
        if(!unreadChatsStr) return;

        const unreadChats: IChatQueueObjectLocalStorage = JSON.parse(unreadChatsStr);
        Object.keys(unreadChats).forEach((chatId: string) => {
            const queues: IChatMsgAPI[] = unreadChats[chatId].queues;
            this.queue[chatId] = new Queue<IChatMsgAPI>(chatId);
            this.queue[chatId].set(queues);
        });
    }
    
}

// export ChatQueue class instance (singleton)
export const __chatQueue = new ChatQueue();
